import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";

const AccordionItem = props => {
    const {index, title, content, isActive} = props;
    const contentRef = React.createRef();
    const [height, setHeight] = useState(0);

    useEffect(() => {
        // Determine the height of the content
        setHeight(isActive ? contentRef.current.scrollHeight : 0);
        return function cleanup() {
            setHeight(0);
        }
    }, [isActive, contentRef])

    const handleClick = e => {
        // Only allow clicking when it's not inside the content
        if (!contentRef.current?.contains(e.target)) props.onClick();
    }

    return (
        <div className={`accordion-item${isActive ? ' active' : ''}`} onClick={handleClick}>
            <div className="accordion-item-label" key={`accordion_item_label_${index}`}>
                <span className="title" key={`accordion_item_title_${index}`}>{title}</span>
                <img className="indicator" alt="Accordion item state indicator"/>
            </div>
            <div className="accordion-item-content" key={`accordion_item_content_${index}`} ref={contentRef}
                 style={{height: height}}>
                <div className="content-wrapper">
                    {content}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {...state};
}

export default connect(mapStateToProps)(AccordionItem)